import { Route, Routes } from "react-router-dom";
import PageNotFound from "./Pages/PageNotFound";
import Home from "./Pages/Home";
import Detail from "./Pages/Detail";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/track/:id" element={<Detail />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </QueryClientProvider>

  );
}

export default App;
